
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('toggleFiltroPromo');
    const menu = document.getElementById('menuFiltroPromo');
    const selected = document.getElementById('selectedOptionPromo');
    const inputBusqueda = document.getElementById('searchPromo');
    let categoriaActiva = '0';


    if(toggle){
        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
        });
        document.getElementById('dropdownFiltroPromo').addEventListener('click', function (e) {
            e.stopPropagation(); // Evita que se cierre al hacer clic dentro del dropdown
        });
    
        document.addEventListener('click', function (e) {    
            // Solo cerrar si el clic fue fuera del menú y fuera del toggle
            if (!menu.contains(e.target) && !toggle.contains(e.target)) {
                menu.style.display = 'none';
            }
        });
    }
    
    // Filtro por texto
    if(inputBusqueda){
        inputBusqueda.addEventListener('input', function () {
            filtrarPromos(true, true);
        });
    }

    if(toggle){
        // Filtro por categoría (dropdown personalizado con radios)
        document.querySelectorAll('#menuFiltroPromo input[type=radio]').forEach(input => {
            input.addEventListener('change', function () {
                categoriaActiva = this.value;
                selected.textContent = this.parentElement.textContent.trim();
                menu.style.display = 'none';
                filtrarPromos(true, true);
            });
        });
    }

    function filtrarPromos(filtroTexto = true, filtroCategoria = true) {
        const texto = (inputBusqueda?.value || '').toLowerCase();
        const promociones = document.querySelectorAll('.item-promocion');

        promociones.forEach(promocion => {
            const nombre = promocion.dataset.nombre?.toLowerCase() || '';
            const catRaw = promocion.dataset.categoria || '';;

            // Normalizamos categorías: "grandes-almacenes,hosteleria" -> ["grandes-almacenes","hosteleria"]
            const categorias = catRaw
                .split(/[,\|;\s]+/)
                .map(s => s.trim().toLowerCase())
                .filter(Boolean);

            const activa = String(categoriaActiva || '').toLowerCase();

            const coincideTexto =
                !filtroTexto || texto.length < 3 || nombre.includes(texto);

            const coincideCategoria =
                !filtroCategoria || activa === '0' || categorias.includes(activa);

            if (coincideTexto && coincideCategoria) {
                promocion.style.display = '';
            } else {
                promocion.style.display = 'none';
            }
        });
    }
});




